"use strict";
import React from "react";
import Account from "../api/account";
import CarrierService from "../services/carrier_service";
import EmailMergerView from "./email_merger_view";
import WaitingSpinner from "../components/waiting_spinner";
var EmailMergerWrapper = React.createClass({
  getInitialState: function() {
    return {
      loading: true,
      carrier: null
    };
  },
  componentDidMount: function() {
    this.resolveCarrier();
  },
  unknownCarrier: function() {
    return { id: "", name: `Unknown ${Account.carrierTerm()}` };
  },
  resolveCarrier: function() {
    if (!this.props.carrierId) {
      this.setState({ loading: false, carrier: this.unknownCarrier() });
      return;
    }
    CarrierService.carrierWithId(this.props.carrierId).then(
      (carrier) => {
        this.setState({ loading: false, carrier });
      },
      () => {
        this.setState({ loading: false, carrier: this.unknownCarrier() });
      }
    );
  },
  render: function() {
    if (this.state.loading) {
      return /* @__PURE__ */ React.createElement(WaitingSpinner, { when: true });
    }
    return /* @__PURE__ */ React.createElement(
      EmailMergerView,
      {
        carrier: this.state.carrier,
        emailId: this.props.emailId,
        location: { query: {} },
        onCancel: this.props.onCancel,
        mergeComplete: this.props.mergeComplete
      }
    );
  }
});
export default EmailMergerWrapper;
